/**
* Experience Module - Full Width
**/

VP = window.VP || {};

(function( $ ) {
  VP.experienceFullWidthModule = {
    window: $(window),

    init: function () {
      var _this = this;
      if ( VP.helpers.isMobile() ) {
        // console.log("[experienceFullWidthModule] delay exp init for mobile");
        _this.eventHandlers();
      }
      else {
        _this.initexperienceFullWidthModules();
      }
    },
    checkScrollPosition: function() {
      var _this = this;
      var $sliderFulls = $(".vp-experienceFullWidth-module:not('.loaded')");
      if ( !$sliderFulls.length ) {
        // console.log("[experienceFullWidthModule] checkScrollPosition all loaded")
        return;
      }
      buffer = $(window).height();  // buffer is one full page height;
      windowTop = $( window ).scrollTop();
      windowBottom = windowTop + $(window).height() + buffer;


      if ($sliderFulls.length >= 1) {
        $sliderFulls.each(function() {
          $sliderFull = $(this);
          if ($sliderFull.offset().top < windowBottom) {
            // if any of them reach window, load them all
            $sliderFulls.addClass("loaded");
            _this.initexperienceFullWidthModules();
          }
        })

      }
    },
    eventHandlers: function() {
      var _this = this;

      VP.documentEvents.onResize( _this.checkScrollPosition.bind( _this ), true );
      VP.documentEvents.onScroll( _this.checkScrollPosition.bind( _this ), true );
      setTimeout(function() {
        _this.checkScrollPosition();
      },500);

    },
    initexperienceFullWidthModules: function() {
      // console.log("[experienceFullWidthModule] initexperienceFullWidthModules");
      var _this = this;
      var $sliderFull = $('.vp-experience-module-fullwidth__blade-items');

      $sliderFull.slick({
        'mobileFirst': true,
        'arrows': true,
        'dots': true,
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'variableWidth': false, 
        'infinite': true,
        'nextArrow': $('.slick-navigation .slick-next'), 
        'prevArrow': $('.slick-navigation .slick-prev'),
        'appendDots': $('.pagination-container'),
        'responsive': [
          {
            'breakpoint': 699,
            'settings': {
              'slidesToShow': 1,
              'slidesToScroll': 1,
              'variableWidth': false,
              'infinite': true,
              'dots': true,
            },
          },
          {
            'breakpoint': 999,
            'settings': {
              'slidesToShow': 1,
              'slidesToScroll': 1,
              'variableWidth': false,
              'infinite': true,
              'dots': true,
            },
          },
        ],
      });    
      // Force Slick to refresh dots
      $sliderFull.slick('slickSetOption', 'dots', true, true);

      // Add debugging logs
      $sliderFull.on('afterChange', function(event, slick, currentSlide) {
        // console.log('Current slide:', currentSlide);
        // console.log('Active dot:', $('.slick-dots li.slick-active'));
      });
  
    },
  };
})(jQuery);
